import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=315353d0&scoped=true&"
import script from "./ProductAdd.vue?vue&type=script&lang=ts&"
export * from "./ProductAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAdd.vue?vue&type=style&index=0&id=315353d0&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315353d0",
  null
  
)

export default component.exports